<template>
  <div class="col-md-6">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new'
  },
  inject: ['$validator'],
  name: 'c-endereco',
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  data() {
    return {
      logradouro: ''
    };
  },
  computed: {
    endereco() {
      return this.$store.state.endereco;
    }
  },
  asyncComputed: {
    valueComputed() {
      let value;

      if (this.endereco.cep) value = this.endereco.logradouro;
      else value = this.value;

      this.logradouro = value;

      return value;
    }
  },
  watch: {
    logradouro(value) {
      this.$emit('input', value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Logradouro.vue